/**
 * Delivery Page
 * Main delivery logging interface
 */

import { Package, Clock, AlertCircle } from 'lucide-react'
import { Link } from 'react-router-dom'
import { DeliveryForm } from './DeliveryForm'
import { DeliveryHistory } from './DeliveryHistory'
import { Card, Button } from '../ui'
import { useAppStore } from '../../stores'

export function DeliveryPage() {
  const getTodayClockStatus = useAppStore((state) => state.getTodayClockStatus)
  const clockStatus = getTodayClockStatus()

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-black rounded-lg">
            <Package className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-medium text-gray-900">Log Delivery</h1>
            <p className="text-sm text-gray-500">Take a photo and log your delivery</p>
          </div>
        </div>
      </div>
      
      {/* Clock In Required Message */}
      {!clockStatus.clockedIn ? (
        <Card className="bg-yellow-50 border-yellow-200">
          <div className="text-center py-8">
            <AlertCircle className="w-12 h-12 text-yellow-500 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Clock In Required</h3>
            <p className="text-gray-600 mb-6">
              You must clock in before logging deliveries. Please go to the Clock page to start your shift.
            </p>
            <Link to="/clock">
              <Button variant="primary" size="lg">
                <Clock className="w-5 h-5 mr-2" />
                Go to Clock Page
              </Button>
            </Link>
          </div>
        </Card>
      ) : (
        <>
          {/* Form - Only show when clocked in */}
          <DeliveryForm />
        </>
      )}
      
      {/* History - Always show */}
      <DeliveryHistory />
    </div>
  )
}
